import jQuery from 'jquery';
let $ = jQuery;

HSN.Breadbox2 = function (config) {
    var scope = this;

    this.container = $('#breadbox');
    this.cmsCells = $([]);
    this.lastHeight = 0;
    this.triggerClass = 'no-slim-bb';
    this.linksBeforeCollapse = 12;

    // This is not implemented
    this.hasBrandsFlyout = config.hasBrandsFlyout ? true : false;

    this.init = function () {
        // Select only relevant .cms-cell's to calculate height
        scope.cmsCells = $('.cms-cell')
            .filter(function (i, e) {
                return !$(e).find('#breadcrumb, #breadbox').length;
            }).filter(function (i, e) {
                return (i === 0 || $(e).is('.first'));
            });

        scope.container.find('dt').on('click', scope.containerToggleClick);

        scope.container.find('.hidden-trigger')
            .off('click', scope.hiddenTriggerClick)
            .on('click', scope.hiddenTriggerClick);

        if (!Modernizr.touchevents) {
            HSN.Tooltip(this.container.find('[data-tooltip]'));
        }
    };

    this.unload =  function () {
        clearInterval(scope.ResizerInterval);
    };

    this.resize = function (forceResize) {
        var breadboxHeight = 0;

        scope.cmsCells.each(function (i, e) {
            breadboxHeight += $(e).outerHeight();
        });

        // Padding adjustment
        breadboxHeight -= 6;

        if (breadboxHeight <= 0) {
            breadboxHeight = 0;
        }

        if (scope.lastHeight === breadboxHeight && !forceResize) {
            return;
        }

        scope.lastHeight = breadboxHeight;
        scope.container.css({ minHeight: breadboxHeight });
    };

    this.containerToggleClick = function (e) {
        var cur = $(this);
        var curContainer = cur.find(' + dd ');
        var expanded = cur.is('.expanded');

        expanded ? curContainer.slideUp(300) : curContainer.slideDown(300);

        cur.toggleClass('expanded');
        cur.attr('aria-expanded', expanded ? false : true);
    };

    this.hiddenTriggerClick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        var cur = $(this);
        var expanded = cur.is('.expanded');
        var title = cur.data('title');
        var curText = cur.find('.text');
        var parent = cur.parents('dd').eq(0);
        var iHiddenUL = parent.find('.hidden-ul');

        if (expanded) {
            iHiddenUL.slideUp(300);

            cur.removeClass('expanded');
            curText.text('See more ' + title);
        }
        else {
            iHiddenUL.slideDown(300);

            cur.addClass('expanded');
            curText.text('See less ' + title);

            // ADA
            iHiddenUL.find('> li > a').eq(0).focus();
        }  
    };

    $(document).ready(function () {
        scope.init();
        scope.resize();
        if ($('.filtered-by').length > 1) {
            $('html, body').scrollTop($('#breadcrumb').offset().top);
        } 
        $(window).on('load', scope.resize);
        scope.ResizerInterval = setInterval(scope.resize, 1000);
    });
};

HSN.Breadbox2.prototype = {};


// WEBPACK FOOTER //
// ./assets/js/HSN/Breadbox2.js